<template v-if="envName === 'stater'">
    <br />
    +7 (940) 999-11-33, info@statera.su <br />
    384900, Республика Абхазия, <br />
    г.Сухум, ул. Лакоба, д.34 <br />
    <br />
</template>     